export default {
  selection: false,
  searchFields: [
    // 搜索组件的配置项
    {
      name: "出运单号",
      value: "ship_no",
      type: "input",
      isFixed: true,
      span: 4,
    },
    {
      name: "发货备注（业务）",
      value: "remark",
      type: "input",
      isFixed: true,
      span: 4,
    },
  ],
  columns: [
    // 表格列的配置
    {
      label: "计划日期",
      prop: "create_time",
    },
    {
      label: "客户名字",
      prop: "cst_name_ch",
    },
    {
      label: "相关订单",
      prop: "ord_no",
    },
    {
      label: "出运单号",
      prop: "ship_no",
      type: "shipNo",
    },
    {
      label: "出运总数",
      prop: "shipping_num",
    },
    {
      label: "发货日期",
      prop: "shipping_time",
    },
    {
      label: "承运货代",
      prop: "spr_name_ch",
    },
    {
      label: "发货渠道",
      prop: "shipping_name_ch",
    },
    {
      label: "物流单号",
      prop: "shipping_waybill_no",
      type: "waybillNo",
    },
    {
      label: "收费重量",
      prop: "weight",
    },
    {
      label: "打包费",
      prop: "packing_fee_total",
    },
    {
      label: "出运费",
      prop: "shipping_cost",
    },
    {
      label: "总运费",
      prop: "shipping_total",
    },
    {
      label: "签收日期",
      prop: "receipt_time",
    },
    {
      label: "发货备注（仓库）",
      prop: "delivery_remark",
    },
    {
      label: "操作",
      type: "operate_btn",
      prop: "",
      width: "100px",
    },
  ],
};
